var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, PropSync, Vue } from 'vue-property-decorator';
import { getRebornUrl } from '@/shared/utils/helpers';
let PhoneValidationIframeModal = class PhoneValidationIframeModal extends Vue {
    constructor() {
        super(...arguments);
        this.retryTimers = [];
    }
    get iframeSrc() {
        const infosetId = this.$route.params.infosetId || this.$attrs.infosetId || '';
        return infosetId
            ? `${getRebornUrl()}/validacao-telefone/${infosetId}`
            : `${getRebornUrl()}/validacao-telefone`;
    }
    onLoad() {
        this.clearRetryTimers();
        this.sendInit('onLoad imediato');
        this.retryTimers.push(setTimeout(() => this.sendInit('fallback 500ms'), 500));
        this.retryTimers.push(setTimeout(() => this.sendInit('fallback 2000ms'), 2000));
    }
    sendInit(origem) {
        const iframe = this.$refs.iframe;
        if (!iframe || !iframe.contentWindow)
            return;
        // Check if we have an infoset passed via props or fallback to route params
        // Some contexts (like the infoset list view) don't have infosetId in route params
        const infosetId = this.$route.params.infosetId || this.$attrs.infosetId || '';
        const payload = {
            type: 'VALIDATION_INIT',
            infoSetId: infosetId,
            token: localStorage.getItem('auth_token_default') || '',
            termsAccepted: true,
        };
        iframe.contentWindow.postMessage(payload, '*');
    }
    handleMessage(event) {
        if (!event.data)
            return;
        const tipo = event.data.type;
        if (tipo === 'IFRAME_READY') {
            this.clearRetryTimers();
            this.sendInit('IFRAME_READY handshake');
            return;
        }
        if (tipo === 'CLOSE_VALIDATION_MODAL') {
            this.close();
        }
    }
    close() {
        this.$emit('close');
    }
    clearRetryTimers() {
        this.retryTimers.forEach(t => clearTimeout(t));
        this.retryTimers = [];
    }
    mounted() {
        window.addEventListener('message', this.handleMessage);
    }
    beforeDestroy() {
        this.clearRetryTimers();
        window.removeEventListener('message', this.handleMessage);
    }
};
__decorate([
    PropSync('open', { default: false })
], PhoneValidationIframeModal.prototype, "showModal", void 0);
PhoneValidationIframeModal = __decorate([
    Component({ name: 'PhoneValidationIframeModal' })
], PhoneValidationIframeModal);
export default PhoneValidationIframeModal;
